"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
	return (mod && mod.__esModule) ? mod : { "default": mod };
};
var chroma_js_1 = __importDefault(require("chroma-js"));
module.exports = function (color, options) {
	if (options === void 0) { options = {}; }
	if (!color || typeof color !== 'string') {
		throw new Error('Please provide a valid "color" string parameter');
	}
	var colorChroma = chroma_js_1.default(color);
	var _a = options.name, name = _a === void 0 ? 'brand' : _a, _b = options.ui, ui = _b === void 0 ? false : _b, _c = options.uiMix, uiMix = _c === void 0 ? 0.2 : _c, _d = options.greyscale, greyscale = _d === void 0 ? false : _d, _e = options.greyscaleMix, greyscaleMix = _e === void 0 ? 0.01 : _e, _f = options.palette, palette = _f === void 0 ? {} : _f;
	function mix(baseColor, amount) {
		return chroma_js_1.default.mix(baseColor, colorChroma, amount, 'lab').hex();
	}
	function addToPalette(name, value) {
		if (!palette[name]) {
			palette[name] = value;
		}
	}
	function addScaleToPalette(name, baseColor, suffixes, padding) {
		var colorScale = chroma_js_1.default.scale(['black', baseColor, 'white']).padding(padding).colors(suffixes.length);
		suffixes.forEach(function (suffix, index) { return addToPalette("" + name + suffix, colorScale[index]); });
	}
	var colorScale = ['-darkest', '-darker', '-dark', '', '-light', '-lighter', '-lightest'];
	var colorInset = 0.125;
	addScaleToPalette(name, colorChroma, colorScale, colorInset);
	if (ui) {
		var uiScale = ['-dark', '', '-light'];
		var uiLightDarkInset = 0.25;
		addScaleToPalette('cta', colorChroma.set('hsl.h', '+150'), uiScale, uiLightDarkInset);
		addScaleToPalette('info', mix('#3df', uiMix), uiScale, uiLightDarkInset);
		addScaleToPalette('warning', mix('#fd0', uiMix), uiScale, uiLightDarkInset);
		addScaleToPalette('success', mix('#3e4', uiMix), uiScale, uiLightDarkInset);
		addScaleToPalette('danger', mix('#f34', uiMix), uiScale, uiLightDarkInset);
	}
	if (greyscale) {
		addToPalette('black', mix('#292929', greyscaleMix));
		addToPalette('grey-darkest', mix('#484848', greyscaleMix));
		addToPalette('grey-darker', mix('#6f6f6f', greyscaleMix));
		addToPalette('grey-dark', mix('#959595', greyscaleMix));
		addToPalette('grey', mix('#c2c2c2', greyscaleMix));
		addToPalette('grey-light', mix('#e1e1e1', greyscaleMix));
		addToPalette('grey-lighter', mix('#f5f5f5', greyscaleMix));
		addToPalette('grey-lightest', mix('#fafafa', greyscaleMix));
		addToPalette('white', '#ffffff');
		addToPalette('transparent', 'transparent');
	}
	return palette;
};
